import { useState, useEffect } from "react";
import {
  Group,
  Text,
  Code,
  SegmentedControl,
  Alert,
  Loader,
  Center,
  ScrollAreaAutosize,
  Badge,
  NumberFormatter,
  Button,
} from "@mantine/core";
import ResponseDetails from "../ResponseDetails";
import CopyTextActionIcon from "../CopyTextActionIcon";
import { IconTrash } from "@tabler/icons-react";
import { useBulkStore } from "./store";
import { modals } from "@mantine/modals";

export default function PlaygroundBulkDetails() {
  const selectedBulkCall = useBulkStore((state) => state.selectedBulkCall);
  // const setSelectedBulkCall = useBulkStore(
  //   (state) => state.setSelectedBulkCall
  // );

  const [displayMode, setDisplayMode] = useState("markdown");
  const [deleting, setDeleting] = useState(false);
  const { getBulkDetails, bulkDetails, deleteBulkCall } = useBulkStore();

  useEffect(() => {
    getBulkDetails(selectedBulkCall.id);
  }, [selectedBulkCall, getBulkDetails]);

  if (!selectedBulkCall) return <Text>Select a bulk call to see details</Text>;

  const openConfirmModal = (callback) =>
    modals.openConfirmModal({
      title: "Really delete this call?",
      children: (
        <Text size="sm">
          This will delete the call and all its responses. Are you sure you want
          to do this?
          <br />
          This action cannot be undone.
        </Text>
      ),
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => callback(),
    });

  return (
    <>
      <Group mb="sm" justify="space-between">
        <Group>
          <Text fw={500}>Prompt</Text>

          <CopyTextActionIcon text={selectedBulkCall.prompt} />
          <Badge variant="light" radius="sm">
            <NumberFormatter
              value={selectedBulkCall.prompt.length}
              thousandSeparator
            />
          </Badge>
        </Group>
        <Button
          leftSection={<IconTrash size={16} stroke={1.5} />}
          variant="outline"
          loading={deleting}
          color="red"
          onClick={() =>
            openConfirmModal(() => {
              deleteBulkCall(selectedBulkCall.id).finally(() => {
                setDeleting(false);
              });
            })
          }
        >
          Delete
        </Button>
        {/* <Button
          variant="outline"
          size="sm"
          leftSection={<IconDeviceFloppy />}
          onClick={async () => {
            var dto = await createPrompt({
              promptText: selectedBulkCall.prompt,
            });
            setLocation(`/prompts/edit/${dto.id}`);
          }}
        >
          Save as template
        </Button> */}
      </Group>

      <ScrollAreaAutosize mah="40vh">
        <Code
          mb="md"
          block
          style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}
        >
          {selectedBulkCall.prompt}
        </Code>
      </ScrollAreaAutosize>

      <Group mt="md" mb="xs" justify="space-between">
        <Text fw={500}>{bulkDetails?.pairs.length} Responses</Text>

        <SegmentedControl
          value={displayMode}
          onChange={setDisplayMode}
          data={[
            { label: "Markdown", value: "markdown" },
            { label: "Raw", value: "raw" },
            { label: "Monospace", value: "mono" },
          ]}
        />
      </Group>

      {bulkDetails == null && (
        <Center>
          <Loader />
        </Center>
      )}

      {bulkDetails?.pairs.length === 0 && (
        <Alert>No responses for this prompt could be found.</Alert>
      )}

      {bulkDetails?.pairs.map((p) => (
        <ResponseDetails
          key={p.request?.id}
          response={p.response}
          request={p.request}
          displayMode={displayMode}
        />
      ))}
    </>
  );
}
